import { REQUEST_URLS, fetcher } from '@/endpoints/fionaMainApi';
import { AccountPropertyManagementCompany } from '@/types/accountPropertyManagementCompany';
import { PaginatedResult } from '@/types/paginatedResult.interface';
import useSWRImmutable from 'swr/immutable';

export interface FetchUserPMCsParams {
  search: string;
  limit?: number;
}

export const useGetAccountPropertyManagementProperties = (queryParams: FetchUserPMCsParams) => {
  const { data, error, isLoading, mutate } = useSWRImmutable<
    PaginatedResult<AccountPropertyManagementCompany>,
    Error
  >(REQUEST_URLS.FETCH_ACCOUNT_MANAGEMENT_COMPANIES(queryParams), fetcher);
  return {
    data,
    isLoading,
    isError: error,
    mutate,
  };
};

export const useGetAccountPropertyManagementCompanyById = (id: string | null) => {
  const { data, error, isLoading } = useSWRImmutable<AccountPropertyManagementCompany, Error>(
    id ? REQUEST_URLS.FETCH_ACCOUNT_MANAGEMENT_COMPANY_BY_ID(id) : null,
    fetcher,
  );
  return { data, isLoading, isError: error };
};
